import type { PropsWithChildren } from 'react';

import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { PATH_DASHBOARD } from '../../routes/paths';

type Tab = {
  label: string;
  value: string;
};

export const defaultTabs: Tab[] = [
  {
    label: 'active',
    value: 'active',
  },
  {
    label: 'ended',
    value: 'ended',
  },
  {
    label: 'all',
    value: 'all',
  },
];

type PlacementListNavigatorContextType = {
  currentTab: string;
  tabs: Tab[];
};

const defaultPlacementListNavigatorContextValue = {
  currentTab: 'active',
  tabs: defaultTabs,
};

export const PlacementListNavigatorContext =
  createContext<PlacementListNavigatorContextType>(
    defaultPlacementListNavigatorContextValue
  );

type PlacementListNavigatorContextProviderProps = PropsWithChildren<any>;

export const PlacementListNavigatorContextProvider = ({
  children,
}: PlacementListNavigatorContextProviderProps) => {
  const [contextValue, setContextValue] =
    useState<PlacementListNavigatorContextType>(
      defaultPlacementListNavigatorContextValue
    );

  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname) {
      let currentTab = pathname
        .replace(`${PATH_DASHBOARD.placement.list}`, '')
        .replace('/', '');
      currentTab = currentTab || defaultTabs[0].value;
      setContextValue((prev) => ({ ...prev, currentTab }));
    } else {
      navigate(PATH_DASHBOARD.placement.list);
    }
  }, [navigate, pathname]);

  return (
    <PlacementListNavigatorContext.Provider value={{ ...contextValue }}>
      {children}
    </PlacementListNavigatorContext.Provider>
  );
};

export const usePlacementListNavigatorContext = () => {
  return useContext(PlacementListNavigatorContext);
};
